/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/session/register"/>
import * as extender from "Core/Medius.Core.Web/Scripts/Medius/session/extender";
import * as $ from "jquery";

export function init() {
    const sessionExtender = extender.create();

    $(window).bind("click keypress", sessionExtender.extendSession);
}
